import React from 'react'
import { useAuthStore } from '@/store/authStore'
import type { Lesson } from '@/types'

export function useLessonAuth(lesson: Lesson | null) {
  const { user, isAuthenticated } = useAuthStore()

  const canHost = React.useMemo(() => {
    if (!isAuthenticated || !user || !lesson) return false

    // Lesson host can always instruct
    if (lesson.host?.id === user.id) return true

    // Captains and admins can host (server validates course access)
    if (user.role === 'captain' || user.role === 'admin') return true

    return false
  }, [isAuthenticated, user, lesson])

  const canPlay = React.useMemo(() => {
    // Anyone can play (including guests)
    return true
  }, [])

  const canView = React.useMemo(() => {
    if (!isAuthenticated || !user || !lesson) return false

    // Host can always view
    if (lesson.host?.id === user.id) return true

    // Captains and admins can view
    if (user.role === 'captain' || user.role === 'admin') return true

    return false
  }, [isAuthenticated, user, lesson])

  return {
    canHost,
    canPlay,
    canView,
    user,
    isAuthenticated
  }
}
